import { render, staticRenderFns } from "./Newsdetail.vue?vue&type=template&id=5c3a492b&scoped=true&"
import script from "./Newsdetail.vue?vue&type=script&lang=js&"
export * from "./Newsdetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c3a492b",
  null
  
)

export default component.exports